import React from "react";
import Grid2 from "@mui/material/Grid2";

function AppBarOffset() {
  return (<Grid2 container size={12} style={{height: "64px"}}></Grid2>);
}

export default AppBarOffset;